<template>
  <b-modal
    ref="modal"
    title="Crop to image"
    @hide="closeHandler"
  >
    <template #modal-footer>
      <ButtonPrimary
        variant="primary"
        :disabled="isLoading"
        @click="accept"
      >
        Yes
      </ButtonPrimary>
      <ButtonOutline
        variant="outline-primary"
        :disabled="isLoading"
        @click="$refs.modal.hide()"
      >
        No
      </ButtonOutline>
    </template>

    <b-form-group>
      <b-form-radio
        v-model="isReplace"
        :value="false"
      >
        Copy before crop
      </b-form-radio>
      <b-form-radio
        v-model="isReplace"
        :value="true"
      >
        Replace image file after crop
      </b-form-radio>
    </b-form-group>
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import mixinModal from './mixin'
import { createNamespacedHelpers } from 'vuex'
import {MUTATIONS} from "../../../../store/file-browser";
import Requests from "../../../../services/api/file-browser";

const { mapGetters, mapMutations, mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "CropModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [
    mixinModal
  ],
  data: () => ({
    isReplace: false,
    isLoading: false,
  }),
  computed: {
    ...mapGetters(['selectedItems'])
  },
  methods: {
    ...mapMutations([MUTATIONS.CLEAR_SELECTION]),
    ...mapActions(['fetchList', 'navigateToUploadedFile']),
    async accept() {
      this.isLoading = true;
      try {
        let isProduct = this.selectedItems.find(item => item.product_name !== undefined);
        await Requests.saveCropImages(this.selectedItems.map(({ id }) => id).join(','), this.isReplace, isProduct ? 1 : 0)
        toastr.success('Successfully cropped')
        if (!this.isReplace) {
          await this.navigateToUploadedFile();
        } else {
          this.fetchList();
        }
      } catch (error) {
        toastr.error('Something went wrong while cropping.');
      } finally {
        this[MUTATIONS.CLEAR_SELECTION]();
        this.isLoading = false;
        this.close();
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
